import moment from "moment-timezone";
import apiEndpoints from "@/services/apiEndpoints";
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      data: [],
      isLoading: false,
      conditionDate: [],
      filters: {
        date: this.$route.query.date !== undefined && this.$route.query.date ? this.$route.query.date : moment().format("YYYY-MM-DD")
      },
      DAY_OF_WEEKS: ['日', '月', '火', '水', '木', '金', '土'],
      zzWorkOrderTypes: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const sendApi = await this.$http.get(apiEndpoints.daily_report_transportation, this.filters);
      const {status, data} = sendApi;

      if (status && data.result) {
        if (data.result.dailyReports.length !== 0) {
          this.data = data.result.dailyReports;
          this.conditionDate = data.result.condition;
        } else {
          this.$router.push({path: '/factories', query: {fromMenu: 0, date: this.filters.date}});
        }
      }
      this.isLoading = false;
      this.$nextTick(() => {
        this.scrollToSchedule()
      });
    },
    backToList() {
      const previousRoute = this.$route.params.previousRoute;
      this.$router.push({
        name: 'home',
        query: previousRoute && previousRoute.query ? previousRoute.query : {}
      })
    },
    prevDate() {
      this.filters.date = moment(this.filters.date, "YYYY-MM-DD").subtract(1, 'days').format("YYYY-MM-DD");
      this.getData()
    },
    nextDate() {
      this.filters.date = moment(this.filters.date, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
      this.getData()
    },
    showBadge6(item) {
      if (!item.is_schedule_canceled && item['is_transport_completed']) return '完了'
      if (!item.is_schedule_canceled && !item['is_transport_completed']) return '未完了'
      if (item.is_schedule_canceled) return 'キャンセル'
      return ' '
    },
    getDayAlert() {
      return this.findDayAlert()?.system_code_value
    },
    formatDateAlert(item, device) {
      let date = item.work_order_json.updated_at
      if (!date) {
        date = item.work_order_json.created_at
      }

      let dateOrigin = moment(date, "YYYY-MM-DD HH:mm:ss");
      if (device == "sp") {
        return '更新日：' + dateOrigin.format('MM月DD日');
      }
      return '更新日' + dateOrigin.format('YYYY年MM月DD日') + '（' + this.DAY_OF_WEEKS[dateOrigin.day()] + '）'
    },
    showDateAlert(item) {
      if (!item.work_order_json) return false;
      let date = item.work_order_json.updated_at;
      if (!date) {
        date = item.work_order_json.created_at;
      }
      let dateOrigin = moment(date, "YYYY-MM-DD HH:mm:ss")
      let addDay = dateOrigin.add(this.getDayAlert(), 'days').format("YYYY-MM-DD");
      let current = moment().format("YYYY-MM-DD")
      return current <= addDay;

    },
    getColorBadge6(item) { // 運搬完了ステータス
      if (!item.is_schedule_canceled && item['is_transport_completed']) return this.$constant.statusHandle.complete;
      if (!item.is_schedule_canceled && !item['is_transport_completed']) return this.$constant.statusHandle.incomplete;
      if (item.is_schedule_canceled) return this.$constant.statusHandle.cancel;
    },
    getColorTextBadge6(item, index) {
      let color = this.getColorBadge6(item, index)
      if (color == this.$constant.statusHandle.incomplete) {
        return this.$constant.statusHandle.disposal_complete_gray
      }
      return '#ffffff'
    },
    openworkHistoryModal(item) {
      this.$refs.workHistory.openModal(item.work_order_json.id, item.work_order_json.name);
    },
    getCommentToUser(wastesOrServiceBySchedule) {
      return wastesOrServiceBySchedule.map(waste_or_services_by_schedule => {
        return [
          waste_or_services_by_schedule?.comment_to_user,
        ].filter(x => !!x).join('')
      }).filter(x => !!x).join('<br>');
    },
    scrollToSchedule() {
      let index = this.$route.query.index ?? null
      if (!index) {
        return
      }
      const schedule_element = document.getElementById(`schedule_${index}`);
      if (schedule_element) {
        schedule_element.scrollIntoView({behavior: 'smooth'});
      }
    },
  },
  computed: {
    ...mapGetters("options", ["options_tables"]),
    showDate() {
      let dateOrigin = moment(this.filters.date, 'YYYY-MM-DD');
      return dateOrigin.format('YYYY年MM月DD日') + `（${this.DAY_OF_WEEKS[dateOrigin.day()]}）`;
    },
    showSelectFactory() {
      let result = false;
      if (this.data[0] === undefined) return ''
      if (!this.data[0]['schedule']) return ''
      if (this.data[0]['schedule']['assigned_staffs_by_schedule'][0] === undefined) return ''
      if (!this.data[0]['schedule']['assigned_staffs_by_schedule'][0]['department']) return ''
      result = this.data[0]['schedule']['assigned_staffs_by_schedule'][0]['department']['zz_division_id'] === this.$constant.DEPARTMENT['environmental_management_department']
      return result
    },
    formatHour() {
      return dateTime => moment(dateTime, "YYYY-MM-DD HH:mm:ss").format('YYYY/MM/DD HH:mm')
    },
    showBadge5: function () {
      const vm = this;
      return function (item) {
        if (vm.zzWorkOrderTypes === undefined || vm.zzWorkOrderTypes.length === 0) {
          vm.zzWorkOrderTypes = vm.options_tables.zz_work_order_types
        }
        let zzWorkOrderTypeId = item.work_order_json ? item.work_order_json.zz_work_order_type_id : null
        if (vm.zzWorkOrderTypes !== undefined && vm.zzWorkOrderTypes.length !== 0) {
          let result = vm.zzWorkOrderTypes.filter(value => {
            return value.id === zzWorkOrderTypeId;
          });
          if (result[0] === undefined) {
            return ' '
          }

          if (zzWorkOrderTypeId === vm.$constant.work_order_type.transshipment_storage) {
            let section = ''
            if (item.schedule.transport_and_hold_section === 1) {
              section = '１';
            } else if (item.schedule.transport_and_hold_section === 2) {
              section = '２';
            }
            return result[0]['work_order_type'] + section;
          }
          return result[0]['work_order_type'];
        }
        return ' '
      };
    },
    colorBadge5: function () {
      const vm = this;
      return function (item) {
        if (vm.zzWorkOrderTypes === undefined || vm.zzWorkOrderTypes.length === 0) {
          vm.zzWorkOrderTypes = vm.options_tables.zz_work_order_types
        }
        let zzWorkOrderTypeId =  item.work_order_json ? item.work_order_json.zz_work_order_type_id : null

        if (vm.zzWorkOrderTypes !== undefined && vm.zzWorkOrderTypes.length !== 0) {
          let result = vm.zzWorkOrderTypes.filter(value => {
            return value.id === zzWorkOrderTypeId;
          });
          if (result[0] === undefined) {
            return ''
          }
          return this.$constant.workOrderTypeBgColor[result[0]['id']];
        }
        return ''
      };
    },
    showUserName() {
      if (this.data[0] === undefined) return ''
      if (!this.data[0]['schedule']) return ''
      if (this.data[0]['schedule']['assigned_staffs_by_schedule'][0] === undefined) return ''
      return this.data[0]['schedule']['assigned_staffs_by_schedule'][0]['user_name']
    },
    showProcessCompany() {
      const vm = this;
      return function (item) {
        if (!item.work_order_json) return false
        const workOrderType = vm.$constant.work_order_type;
        return !(item.work_order_json.zz_work_order_type_id === workOrderType.work || item.work_order_json.zz_work_order_type_id === workOrderType.others);
      }
    },
    showNext() {
      if (this.conditionDate.length === 0) return false
      let conditionEnd = moment(this.conditionDate.end_datetime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD")
      return this.filters.date < conditionEnd;
    },
    showPrev() {
      if (this.conditionDate.length === 0) return false
      let conditionStart = moment(this.conditionDate.start_datetime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD")
      return this.filters.date > conditionStart;
    }
  }
};
